module.exports = __webpack_public_path__ + "static/media/startLines.0b125349.svg";